import asyncForever from 'async/forever';
import { Sha256 } from 'asmcrypto.js';

import { calcChunkSize } from './chunk_size_helper';

export default {
  hashFile,
};

const g_hashCacheMap = new Map();

function hashFile(file, done) {
  const { webkitRelativePath, lastModified, size } = file;
  const key = webkitRelativePath + '-' + lastModified + '-' + size;
  if (g_hashCacheMap.has(key)) {
    done(null, g_hashCacheMap.get(key));
  } else {
    _internalHashASM(file, (err, result) => {
      if (!err) {
        g_hashCacheMap.set(key, result);
      }
      done(err, result);
    });
  }
}
function _internalHashASM(file, done) {
  const { size } = file;
  const chunk_size = calcChunkSize(size);
  let start_pos = 0;
  const part_list: any[] = [];
  const result_list: any[] = [];
  asyncForever(
    (done) => {
      const bytes_left = size - start_pos;
      if (bytes_left === 0) {
        done('done');
      } else {
        const part_size = Math.min(chunk_size, bytes_left);
        const opts = {
          file: file.slice(start_pos, start_pos + part_size),
        };
        _hashBlockASM(opts, (err, part_hash, result) => {
          start_pos += part_size;
          part_list.push({ part_size, part_hash });
          result_list.push(result);
          done(err);
        });
      }
    },
    (err) => {
      if (err === 'done') {
        err = null;
      }
      let digest;
      if (!err) {
        if (part_list.length === 1) {
          digest = part_list[0].part_hash;
        } else {
          const hash: any = new Sha256();
          result_list.forEach((result) => hash.process(result));
          hash.finish();
          digest = Array.from(hash.result).map(_toHex).join('');
        }
      }
      done(err, { part_list, hash: digest });
    }
  );
}
function _hashBlockASM(params, done) {
  const { file } = params;
  const block_hash: any = new Sha256();
  const reader = file.stream().getReader();
  asyncForever(
    (done) => {
      reader.read().then(
        (result) => {
          const { value } = result;
          if (value && value.length > 0) {
            block_hash.process(value);
          }
          done(result.done ? 'done' : null);
        },
        (err) => {
          done(err);
        }
      );
    },
    (err) => {
      if (err === 'done') {
        err = null;
      }
      let block_digest;
      if (!err) {
        block_hash.finish();
        block_digest = Array.from(block_hash.result).map(_toHex).join('');
      }
      done(err, block_digest, block_hash.result);
    }
  );
}
function _toHex(i) {
  return ('0' + i.toString(16)).slice(-2);
}
